// Matches Podcast.js's real big-thumbnail list of shows.
export default function PodcastListSkeleton({ rows = 3 }) {
    return (
        <div className="d-flex flex-column gap-3">
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="rounded-4 p-4" style={{ background: 'rgba(255,255,255,0.55)', border: '1px solid rgba(var(--bs-primary-rgb), 0.08)' }}>
                    <div className="d-flex gap-3 align-items-start">
                        <div className="shine rounded-3 flex-shrink-0" style={{ width: 80, height: 80 }} />
                        <div className="flex-grow-1">
                            <div className="shine rounded-3 mb-2" style={{ height: 20, width: '45%' }} />
                            <div className="shine rounded-3" style={{ height: 14, width: '70%' }} />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
